import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { formatInternational, getCountryCodeFromPhoneNumber, } from 'lib-shared-phone-numbers';
import { useCallback, useMemo, useState } from 'react';
import FlagSelect from '../flagSelect';
import { useNumberTable } from '../numberTableContext';
import styles from './moveFlowModal.module.scss';
const MoveFlowModal = ({ isShown, number, selectedFlow, flows, onClose, }) => {
    const { fetchNumbers, phoneNumbers } = useNumberTable();
    const { items, getItemsAsyncStatus } = phoneNumbers;
    const { e164_format: currentNumber } = number;
    const isGetItemsLoading = getItemsAsyncStatus === 'loading';
    const [isLoading, setIsLoading] = useState(false);
    const [selectedNumber, setSelectedItem] = useState(currentNumber);
    const onSelect = useCallback((item) => {
        const { id } = item;
        setSelectedItem(id);
    }, []);
    const onMove = useCallback(() => {
        if (!selectedFlow) {
            return;
        }
        const { id } = selectedFlow;
        setIsLoading(true);
        flows
            .update(id, Object.assign(Object.assign({}, selectedFlow), { location: selectedNumber }))
            .then(() => setIsLoading(false))
            .then(() => onClose())
            .then(() => fetchNumbers());
    }, [
        flows,
        selectedFlow,
        onClose,
        fetchNumbers,
        setIsLoading,
        selectedNumber,
    ]);
    const options = useMemo(() => items.map(({ e164_format, name }) => {
        const flag = getCountryCodeFromPhoneNumber(e164_format) || '';
        const number = formatInternational(e164_format);
        return {
            id: e164_format,
            flag,
            name: `${number} ${name ? `(${name})` : ''}`,
        };
    }), [items]);
    if (!selectedFlow) {
        return null;
    }
    return (_jsxs(Modal, Object.assign({ isOpen: isShown, onClose: onClose }, { children: [_jsx(ModalHead, { title: "Move to another number", onClose: onClose }), _jsxs(ModalBody, Object.assign({ className: styles.modal }, { children: [_jsx("label", Object.assign({ className: styles.label }, { children: "Your phone numbers" })), _jsx(FlagSelect, { items: options, isLoading: isGetItemsLoading, selectedItem: selectedNumber, onSelect: onSelect })] })), _jsxs(ModalFoot, Object.assign({ className: styles.foot }, { children: [_jsx(Button, Object.assign({ variant: "tertiary", onClick: onClose }, { children: "Cancel" })), _jsx(Button, Object.assign({ isLoading: isLoading, onClick: onMove }, { children: "Move" }))] }))] })));
};
export default MoveFlowModal;
